// import { lazy } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { SidebarElement, } from "./SidebarElems";
import { Icon } from "@iconify/react/dist/iconify.js";
// import EventMaster from "../views/forms/EventMaster/EventMaster";
// import EventCreation from "../views/forms/EventCreation/EventCreation";
import DashboardHome from "../views/forms/DashboardHome"
import TotalAvailableFund from "../views/forms/TotalAvailableFund";
import TotalVoucherEntryStatus from "../views/forms/TotalVoucherEntryStatus";
import CashAnalysisReport from "../views/forms/CashAnalysisReport";
import ActivityQuery from "../views/forms/ActivityQuery";
import ActivityWiseExpenditure from "../views/forms/ActivityWiseExpenditure";
import ActivityDetails from "../views/forms/ActivityDetails";
import MonthClosingModule from "../views/forms/MonthClosingModule";
// import Prominent from "../views/forms/ProminentMaster/Prominent";
// import EventCreationList from "../views/forms/EventCreation/EventCreationList";
// import EventEntry from "../views/forms/EventEntry/EventEntry";
// import EventEntryList from "../views/forms/EventEntry/EventEntryList";
// import ProminentPersonalities from "../views/forms/ProminentPersonalities/ProminentPersonalities";
// import ProminentPersonalitiesList from "../views/forms/ProminentPersonalities/ProminentPersonalitiesList";
// import ActivityMaster from "../views/forms/Activity/ActivityMaster";
// import LevelMaster from "../views/forms/LevelMaster/LevelMaster";
// import VenueMaster from "../views/Venue/VenueMaster";


// const WorkAllocationList = lazy(() =>
//   import("../views/forms/WorkAllocationList")
// );

// // Lazy-loaded reports
// const SummaryReportOnScheme = lazy(() =>
//   import("../views/reports/SummaryReportOnScheme")
// );
// const FundingDepartmentWiseReport = lazy(() =>
//   import("../views/reports/FundingDepartmentWiseReport")
// );
// const UserListByDepartment = lazy(() =>
//   import("../views/reports/UserListByDepartment")
// );

export const sideBarList = [
  {
    Component: DashboardHome,
    text: "Home",
    route: "/dashboard",
    permissions: [],
  },

  {
    Component: TotalAvailableFund,
    text: "TotalAvailableFund",
    route: "/total_available_fund",
    permissions: [],
  },
  {
    Component: TotalVoucherEntryStatus,
    text: "TotalVoucherEntryStatus",
    route: "/voucher_entry_status",
    permissions: [],
  },
  {
    Component: CashAnalysisReport,
    text: "CashAnalysisReport",
    route: "/cash-analysis",
    permissions: [],
  },
  {
    Component: ActivityQuery,
    text: "ActivityQuery",
    route: "/activity-query",
    permissions: [],
  },
  {
    Component: ActivityWiseExpenditure,
    text: "ActivityWiseExpenditure",
    route: "/activity-wise-expenditure",
    permissions: [],
  },
  {
    Component: ActivityDetails,
    text: "ActivityDetails",
    route: "/activity-details",
    permissions: [],
  },

    {
    Component: MonthClosingModule,
    text: "MonthClosingModule",
    route: "/month-closing-report",
    permissions: [],
  },



];

export const Sidebar = () => {

  return (
    <div className="z-20 flex flex-col p-3 text-white">
      <SidebarElement to="/dashboard" customCss={"flex justify-start pl-4 "}>
        <div className=" items-start py-2 capitalize">
          <span className="flex items-center space-x-4">
            <span>Home</span>
          </span>
        </div>
      </SidebarElement>

      <SidebarElement to="/total_available_fund" customCss={"flex justify-start pl-4 "} >
        <div className=" items-start py-2 capitalize">
          <span className="flex items-center space-x-4">
            <span>PRI wise Available Fund</span>
          </span>
        </div>
      </SidebarElement>

      <SidebarElement to="/voucher_entry_status" customCss={"flex justify-start pl-4 "} >
        <div className=" items-start py-2 capitalize">
          <span className="flex items-center space-x-4">
            <span>Voucher Entry Status</span>
          </span>
        </div>
      </SidebarElement>

      <SidebarElement to="/cash-analysis" customCss={"flex justify-start pl-4 "} >
        <div className=" items-start py-2 capitalize">
          <span className="flex items-center space-x-4">
            <span>Cash Analysis Report</span>
          </span>
        </div>
      </SidebarElement>

      <SidebarElement to="/activity-query" customCss={"flex justify-start pl-4 "} >
        <div className=" items-start py-2 capitalize">
          <span className="flex items-center space-x-4">
            <span>Activity Query</span>
          </span>
        </div>
      </SidebarElement>
      <SidebarElement to="/activity-wise-expenditure" customCss={"flex justify-start pl-4 "} >
        <div className=" items-start py-2 capitalize">
          <span className="flex items-center space-x-4">
            <span>Activity wise Expenditure</span>
          </span>
        </div>
      </SidebarElement>
      <SidebarElement to="/activity-details" customCss={"flex justify-start pl-4 "} >
        <div className=" items-start py-2 capitalize">
          <span className="flex items-center space-x-4">
            <span>Activity Details</span>
          </span>
        </div>
      </SidebarElement>

      <SidebarElement
        to="/month-closing-report"
        customCss={"flex justify-start pl-4 "} >
        <div className=" items-start py-2 capitalize">
          <span className="flex items-center space-x-4">
            <span>Month Closing Report</span>
          </span>
        </div>
      </SidebarElement>



    </div>
  );
};
